import { render, staticRenderFns } from "./TwoFactorAuthModal.vue?vue&type=template&id=bed03e36&scoped=true"
import script from "./TwoFactorAuthModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthModal.vue?vue&type=style&index=0&id=bed03e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed03e36",
  null
  
)

export default component.exports